import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import LinearProgress from '@material-ui/core/LinearProgress';
import TextField from '@material-ui/core/TextField';

import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';

import DataTableToolbar from '../_Shared/DataTables/DataToolbar';
import DataTable from '../_Shared/DataTables/DataTable';
import CreateModal from '../_Shared/CreateModal';
import AppContent from '../_Shared/Layout/AppContent';

const defaultProvider = { name: '' }
const uuidv4 = require('uuid/v4');

class ProviderList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showCreateModal: false,
            provider: defaultProvider,
            anchorEl: null
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    toggleRowMenu = currentTarget => {
        this.setState((prevState) => {
            return { anchorEl: prevState.anchorEl === currentTarget ? null : currentTarget }
        })
    }

    closeToggleRowMenu = () => {
        this.setState({ anchorEl: null });
    }

    toggleCreateModal = e => {
        const { showCreateModal } = this.state;
        this.setState({ showCreateModal: !showCreateModal, provider: defaultProvider });
    }

    handleInputChange = (name, value) => {
        this.setState((prevState, state) => {
            return { provider: Object.assign({}, prevState.provider, { [name]: value }) }
        });
    }

    selectElement = provider => {
        this.setState({ provider });
    }

    createProvider = e => {
        const { onProviderAdded } = this.props;
        const { provider } = this.state;
        onProviderAdded(Object.assign({}, provider, { id: uuidv4().replace(/-/g, ''), externalFields: [] }));
        this.setState({ showCreateModal: false });
    }

    deleteProvider = event => {
        const { onProviderRemoved } = this.props;
        const { provider } = this.state;
        onProviderRemoved(provider);
        this.setState({ provider: defaultProvider, anchorEl: null });
    }

    render() {
        const { providers, onEdit, loading } = this.props;
        const { showCreateModal, provider, anchorEl } = this.state;
        return (<AppContent>
            {
                loading && <LinearProgress variant="query" />
            }
            <DataTableToolbar title="Providers" numSelected={0} >
                <Tooltip title="Add New">
                    <IconButton onClick={this.toggleCreateModal} color="secondary"><AddCircleIcon /></IconButton>
                </Tooltip>
            </DataTableToolbar>
            {
                providers &&
                <DataTable columns={[{ label: 'Name', field: 'name' }]} anchorEl={anchorEl} rows={providers} toggleRowMenu={this.toggleRowMenu} 
                    onElementSelect={this.selectElement} onCloseToggleRowMenu={this.closeToggleRowMenu}>
                    <MenuItem onClick={() => onEdit(`/data-tools/providers/${provider.id}/manage/settings`, provider)}>
                        <ListItemIcon><EditIcon /></ListItemIcon>
                        <ListItemText inset primary="Settings" />
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={this.deleteProvider}>
                        <ListItemIcon><DeleteForeverIcon /></ListItemIcon>
                        <ListItemText inset primary="Delete" />
                    </MenuItem>
                </DataTable>
            }
            <CreateModal title="Create Provider" open={showCreateModal} closeHandler={this.toggleCreateModal} saveHandler={this.createProvider}>
                <Grid container item spacing={24}>
                    <Grid item xs>
                        <TextField autoFocus value={provider.name} onChange={e => this.handleInputChange('name', e.target.value)} id="name" name="name" label="Provider Name" type="text" fullWidth />
                    </Grid>
                </Grid>
            </CreateModal>
        </AppContent>)
    }
}

ProviderList.propTypes = {
    providers: PropTypes.array.isRequired,
};

export default ProviderList;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Providers/ProviderList.js